import { Controller } from 'stimulus'

// A modal that asks to confirm an action: opened by its button, closed by Dismiss, Escape or a click on the
// backdrop. It's closed before Turbo caches the page, so going back to the page doesn't show it open.
export default class extends Controller {
  static targets = ['openButton', 'modal', 'dialog']

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this)
    this.boundClose = this.close.bind(this)
    document.addEventListener('turbo:before-cache', this.boundClose)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundKeydown)
    document.removeEventListener('turbo:before-cache', this.boundClose)
  }

  open() {
    this.modalTarget.classList.remove('hidden')
    document.addEventListener('keydown', this.boundKeydown)
    this.dialogTarget.focus()
  }

  close() {
    if (this.modalTarget.classList.contains('hidden')) return

    this.modalTarget.classList.add('hidden')
    document.removeEventListener('keydown', this.boundKeydown)
    this.openButtonTarget.focus()
  }

  closeFromBackdrop(event) {
    if (event.target === event.currentTarget) this.close()
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.close()
  }
}
